import { Observable } from 'rxjs';
import { TermsUseResponse } from '../models/terms-use-response.model';
import { UseCase } from '@/core/base/use-case';
import { TermsUseRepository } from '../repositories/rental-policy.respository';

export class GetTermsUseUseCase implements UseCase<never, TermsUseResponse> {
    constructor(private readonly repository: TermsUseRepository) {}

    execute(): Observable<TermsUseResponse> {
        return this.repository.getTermsUse();
    }
}
